import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormEmailCellComponent from './VrunFormEmailCellComponent.vue'

declareVueComponent('vrun-form-email-cell-component', VrunFormEmailCellComponent)